import React, { useState, useEffect } from "react";
import { Card, Row, Col, Container } from "react-bootstrap";
import axios from "axios";
import "./mloLicense.css";
// import Card1 from "../../images/Card1.png";
import htmlParser from "html-react-parser";

export default function EventSection() {

const imgURL = process.env.REACT_APP_CDN_URL;
const [dpaData, setDPAData] = useState();
const [dpahelpData, setDPAHelpData] = useState();

 useEffect(() => {
    const fetchdpaJSON = async () => {
      await axios.get(process.env.REACT_APP_JOIN_OUR_TEAM_JSON).then(
        (response) => {
          //console.log(response.data)
          setDPAData(response.data);
          setDPAHelpData(response.data.dpahelp)
        },
        (error) => {
          console.log(error);
        }
      );
    };

    fetchdpaJSON();
  }, []);
if (dpahelpData) {
  return (
      <>
      <div className="downSection">
        <Container >
          <h5 className="dpaHeading">{htmlParser(dpahelpData.dpahelpHeading1)}</h5>
          <p className="MLOText">{htmlParser(dpahelpData.dpahelpHeading2)}</p>
          <Row>
            {dpahelpData.dpaDetails.map((item, k) => (
              <Col key={k} xs={12} md={12} lg={3}>
                <Card className="dpacard">
                <Card.Img className="card-img" src={imgURL + item.image} /> 
                    <Card.Title className="dpatitle">{htmlParser(item.heading)}</Card.Title>
                    <Card.Text className="dpaDetail">{htmlParser(item.description)}</Card.Text>
                </Card>
              </Col>
              
            ))}
            
          </Row>
        </Container>
        </div>
      </>
    );
  } else {
    return (
      <></>
    );
  }
}
